import React from 'react';
export const CFIconChevronsRight = {
    alias: 'chevrons-right',
    defaultTitle: 'Chevrons Right',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm13.951 5.373 4.828 6a1 1 0 0 1-.01 1.267l-5 6a1 1 0 1 1-1.537-1.28l4.476-5.37-4.316-5.363a1 1 0 1 1 1.56-1.254Zm-8.406-.152a1 1 0 0 1 1.406.152l4.828 6a1 1 0 0 1-.01 1.267l-5 6a1 1 0 1 1-1.537-1.28l4.475-5.371-4.315-5.362a1 1 0 0 1 .153-1.406Z' }))),
};
